/**
 * Sanitized toast wrapper. Drop-in replacement for `sonner`'s toast — every
 * call routes through `brandSanitizer` so vendor names get rewritten into
 * role labels before display.
 *
 *   import { toast } from 'utils/toast';
 *   toast.error('Opus returned an empty spec');   // → "Director AI returned an empty spec"
 *
 * Pass the raw `sonner` import via `?dev=1` to bypass.
 */
import { toast as rawToast } from 'sonner';
import { sanitizeForUser, SANITIZE_DISABLED } from './brandSanitizer';

const wrap = (fn) => (msg, opts) => {
  if (SANITIZE_DISABLED) return fn(msg, opts);
  // toast.* can accept a string OR a JSX node. Only sanitize strings.
  const safe = typeof msg === 'string' ? sanitizeForUser(msg) : msg;
  // Sanitize the description too if present.
  if (opts && typeof opts === 'object' && typeof opts.description === 'string') {
    opts = { ...opts, description: sanitizeForUser(opts.description) };
  }
  return fn(safe, opts);
};

export const toast = {
  success: wrap(rawToast.success),
  error:   wrap(rawToast.error),
  info:    wrap(rawToast.info),
  warning: wrap(rawToast.warning),
  message: wrap(rawToast.message),
  // Forward less-common APIs untouched (promise, custom JSX, etc.)
  promise: rawToast.promise,
  loading: wrap(rawToast.loading),
  custom:  rawToast.custom,
  dismiss: rawToast.dismiss,
};

export default toast;
